import { useEffect, useMemo, useState } from "react"
import moment from "moment";

import { AppBody, DataWrapper, TituloH2 } from "styles/base"
import TitlePage from "components/TitlePage"
import { Btn, useCreditsDetails } from "./useCredits"
import { TableGrid } from "components/TableGrid/TableGrid"
import { BoxBtns, BoxBtnsRelatorios, LinksBack } from "../styles"
import { scrollToTop, useQueryString } from "util/utils"
import { CircularProgress} from "@mui/material";
import { useParams } from "react-router-dom"
import Button from "components/Button";
import { default as Modal } from 'components/modal/modal'
import { postEstorno } from "../services";
import zIndex from "@mui/material/styles/zIndex";
import { consoleStringify } from "util/console";

interface IReportsDetails {

}

interface RouteParams {
  slug: "utilizados" | "distribuidos" | "expirados" | "expirar"
}

const ReportsDetails = ({ }: IReportsDetails) => {
  const { slug: slug_type } : RouteParams = useParams()
  const slug = slug_type

  const { loadDetails, FetchingDetails, setFilterValues,
  tableAllDetails, relatorioListDetails, pageCurrent, modalEstorno,
  setPageCurrent, setTypeConsult, handleClick } = useCreditsDetails()
  
  const [loading, setLoading] = useState(false)
  
  const handleClickAndLoading = async () => {
    try {
      setLoading(true)
      await Promise.resolve(handleClick())
    } catch (err: any) {
      consoleStringify(err);
    } finally {
      setLoading(false)
    }
  }

  const query = useQueryString()
  
  const slugTitle : any = {
    "utilizados" : "Cashback Utilizados",
    "distribuidos" : "Cashback Distribuídos",
    "expirados" : "Cashback Expirados",
    "expirar" : "Cashback a Expirar",
    "estornados" : "Cashback Estornado",
  }

  const init = useMemo(() => {
    setTypeConsult(slug)

    setFilterValues({ 
      idInstancia: query.get('idInstancia'), 
      idUnidade: query.get('idUnidade'),
      periodo: query.get('periodo'),
      dataInicio: query.get('dataInicio'), 
      dataFim: query.get('dataFim'),
    })

    const pagina = parseInt(query.get('page') || "0") - 1
    setPageCurrent(pagina > 0 ? pagina : 0)
  }, [query])
  init

  useEffect(() => scrollToTop({}), [pageCurrent])

  const handlePage = (e : number) => setPageCurrent(e)

  const urlBack = `/home/relatorios?tipo=${slug}&idInstancia=${query.get('idInstancia')}&idUnidade=${query.get('idUnidade')}&periodo=${query.get("periodo")}&dataInicio=${moment(query.get('dataInicio')).format('YYYY-MM-DD')}&dataFim=${moment(query.get('dataFim')).format('YYYY-MM-DD')}&page=0`

  return <>
  {
    modalEstorno()
  }
  <AppBody>
    
    <TitlePage title="Relatórios" />
    <DataWrapper>
      <TituloH2>{slugTitle[slug]}</TituloH2>

      {(loadDetails && relatorioListDetails.rows.length === 0) && <CircularProgress />}

      <TableGrid
        columns={tableAllDetails.head}
        rows={tableAllDetails.rows}
        // handleEdit={handleEdit}
        // loading={load}
        // hasIconLoad={false}
        />

      <div id="app-body"></div>  
      <TableGrid
        columns={relatorioListDetails.head}
        rows={relatorioListDetails.rows}
        // handleEdit={handleEdit}
        // hasIconLoad={false}
        loading={FetchingDetails}
        totalRows={relatorioListDetails.totalRows}
        goTo={handlePage}
        currentPg={pageCurrent}
        />

      <BoxBtnsRelatorios style={{ marginTop: relatorioListDetails.totalRows <= 10 ? '' : '-60px' }}> 
        <LinksBack to={urlBack} style={{zIndex: '2'}}>Voltar</LinksBack>

        <Button style={{zIndex: '2', minWidth: 156}} confirm text="Gerar relatório" 
          onClick={handleClickAndLoading} 
          disabled={relatorioListDetails.totalRows < 1}
          loading={loading} />
      </BoxBtnsRelatorios>

    </DataWrapper>
  </AppBody>
  </>
}
export { ReportsDetails }